import { useState } from 'react';
import config from '../index';
import { investorPages } from '../data/investorPages';
import { PasswordProtected } from '../components/PasswordProtected';

export default function Resources() {
  const [currentPage, setCurrentPage] = useState(investorPages[0]);

  return (
    <PasswordProtected>
        <title>vidi3D Investor Hub</title>
        <meta name="description" content="Access our comprehensive investor information for vidi3D's virtual tour and 3D visualization solutions." />
        <meta property="og:title" content="vidi3D Investor Hub" />
        <meta property="og:type" content="website" />
        <meta property="robots" content="noindex, nofollow" />
        <link rel="canonical" href={`${config.baseUrl}`} />

        <div className="flex w-full">
            {/* Side Menu */}
            <div className="w-64 bg-gray-50 border-r border-gray-200 p-4 min-h-screen">
                <nav className="space-y-1">
                {investorPages.map((page) => (
                    <button
                    key={page.id}
                    onClick={() => setCurrentPage(page)}
                    className={`w-full text-left px-4 py-2 rounded-lg transition-colors
                        ${currentPage.id === page.id 
                        ? 'bg-brand text-white font-semibold' 
                        : 'text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                    {page.title}
                    </button>
                ))}
                </nav>
            </div>
        
          {/* Content Area */}
          <div className="flex flex-col flex-1">
            <h1 className="text-4xl w-full font-bold text-brand p-6 text-center">Investor Hub</h1>
                <div className="flex-1">
                    <iframe
                    key={currentPage.id} // Force iframe refresh when page changes
                    src={`${process.env.PUBLIC_URL}${currentPage.path}`}
                    title={currentPage.title}
                    className="w-full h-full"
                    style={{ 
                        border: 'none',
                        minHeight: 'calc(100vh - 88px)' // Account for header
                    }}
                    />
                </div>
            </div>
        </div>
    </PasswordProtected>
  );
} 